// ES6 兼容组件
import 'babel-polyfill';
import promise from 'es6-promise';
promise.polyfill();

import Vue from 'vue'
import App from './App'
import router from './router/router'
import ElementUI from 'element-ui'
import locale from 'element-ui/lib/locale/lang/zh-CN'
import VideoPlayer from 'vue-video-player'
import http from './router/http'

import './../static/js/jquery-1.8.3.min'
import './../static/js/main'
import "video.js/dist/video-js.css"
import "vue-video-player/src/custom-theme.css"
import '../node_modules/element-ui/lib/theme-chalk/index.css'
import 'animate.css'
import axios from "axios";
import { gsap } from "gsap";
import ScrollTrigger from "gsap/ScrollTrigger";
gsap.registerPlugin(ScrollTrigger);
import '../src/assets/js/home.js';
import VueAMap from 'vue-amap';   //引入高德



// 服务器地址
// Vue.prototype.serverpath = 'http://shkjgw.shkjem.com/api'
// Vue.prototype.serverpath = 'http://localhost:8082/'
Vue.prototype.serverpath = 'https://www.longizn.com'


// 图片服务器地址
// Vue.prototype.imgserver = 'http://shkjgw.shkjem.com/'
// Vue.prototype.imgserver = 'http://localhost:8082'
Vue.prototype.imgserver = 'https://www.longizn.com:8083'

// 跳转后返回顶部
router.afterEach((to, from, next) => {
    window.scrollTo(0, 0);
})

Vue.config.productionTip = false
Vue.use(ElementUI, {
    locale
})
Vue.use(VideoPlayer)
Vue.use(gsap)

new Vue({
    el: '#app',
    router,
    components: {
        App
    },
    template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js